import React from "react";
import { LabelWrapper } from "./Card.styled";
import PropTypes from "prop-types";
// eslint-disable-next-line no-unused-vars
function Chartlabel({
	firstColorId,
	secondColorId,
	firstCaption,
	secondCaption,
	firstAmount,
	secondAmount,
	totalAmount,
}) {
	//percentage calculator
	const calculatePercentage = (value, total) => {
		if (total === 0) {
			return 0;
		}
		return ((value / total) * 100).toFixed(2);
	};
	return (
		<LabelWrapper firstcolor={firstColorId} secondcolor={secondColorId}>
			<section className='firstSection'>
				<div className='firstcolor'></div>
				<div className='firstDetails'>
					<p className='header'>{firstCaption}</p>
					<div>{firstAmount} user(s) </div>
					<div>{calculatePercentage(firstAmount, totalAmount)}%</div>
				</div>
			</section>

			<section className='firstSection'>
				<div className='secondcolor'></div>
				<div className='firstDetails'>
					<p className='header'>{secondCaption}</p>
					<div>{secondAmount} user(s) </div>
					<div>{calculatePercentage(secondAmount, totalAmount)}%</div>
				</div>
			</section>
		</LabelWrapper>
	);
}

Chartlabel.propTypes = {
	firstColorId: PropTypes.string,
	secondColorId: PropTypes.string,
	firstCaption: PropTypes.string,
	secondCaption: PropTypes.string,
	firstAmount: PropTypes.number,
	secondAmount: PropTypes.number,
	totalAmount: PropTypes.number,
};

export default Chartlabel;
